import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-renewal-error-cog',
  templateUrl: './renewal-error-cog.component.html',
  styleUrls: ['./renewal-error-cog.component.css']
})
export class RenewalErrorCogComponent implements OnInit {

  errorMessage: string;

  constructor() { 
    this.errorMessage = localStorage.getItem('RenewalErrorMessage');
  }

  ngOnInit() {
  }

}
